module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar routeLanguageConnections = model.routeLanguageConnectionsSorted || {}\nvar targetRouteID, routeID, langCode\nvar routePickerButtonConfig = config.routePickerButtonConfig || {}\nvar description = model.description || {}\n%>\n<div>\n<section class=\"description <%- description.class || '' %>\">\n<div class=\"symbol\">\n%><i class=\"<%= description.icon || '' %>\" />\n</div>\n<div class=\"content\">\n<%= description.content || '' %>\n<%- description.contentSuffixHtml || '' %>\n</div>\n</section>\n<section class=\"main\">\n<%\nif(utils.collectionSize(model.availableLangCodes) < 1){\n%><div class=\"empty\"><%= storage.__('error:routeTree.missingAvailableLangCodes') %></div><%\n}\nvar routeAttributes = {};\nvar cssClasses = [];\nvar d, routeName = '', routeTitle = '';\nfor(d in resourceData.data.attributes.data || []){\nrouteAttributes = resourceData.data.attributes.data[d]\nrouteID = routeAttributes.routeID\nrouteName = routeAttributes.name\nrouteTitle = ''\nif(model.extendByAdminConnectionInformation){\nif(routeID){\nif(!routeAttributes.level){\nrouteTitle = `#${routeID}`\n} else if(routeAttributes.sourceRouteID && routeAttributes.targetRouteID) {\nrouteTitle = `#${routeID}   via   ${routeAttributes.sourceRouteID} => ${routeAttributes.targetRouteID}`\n}\n}\n} else if(routeAttributes.path) {\nrouteTitle = routeAttributes.path\n}\ncssClasses = ['language']\nif(routeAttributes.level > 1){\ncssClasses.push('secondaryConnection')\n}\n%>\n<div class=\"<%= cssClasses.join(' ') %>\" data-route-id=\"<%- routeAttributes.routeID %>\" data-lang-code=\"<%= routeAttributes.langCode %>\" style=\"--language-sub-level: <%- Math.max(routeAttributes.level, 1) - 1 %>;\" title=\"<%= routeTitle %>\">\n<div class=\"buttons\">\n<% if(routeAttributes.level){ %>\n<%- include('../../base/form/elements/buttons/default', { formMapping: { buttonType: 'connectLanguage', context: 'route', symbolOnly: true } }); %>\n<% } %>\n<%- include('../../base/form/elements/buttons/default', { formMapping: { buttonType: 'open', context: 'routes', symbolOnly: true } }); %>\n<% if(routeAttributes.level === 1){ %>\n<%- include('../../base/form/elements/buttons/default', { formMapping: { buttonType: 'reset', context: 'routes', symbolOnly: true } }); %>\n<%- include('../../base/form/fields/route-picker-button', { formMapping: {}, model: { fieldCode: routeAttributes.langCode, config: routePickerButtonConfig }}); %>\n<% } %>\n</div>\n<div class=\"flag\">\n%><i class=\"<%= (model.availableLangCodes[routeAttributes.langCode] || {}).icon || 'fi fi-flag' %>\" title=\"<%= routeAttributes.langCode %>\" />\n</div>\n<div class=\"routeDetails\">\n<div><%= routeName %></div>\n<div class=\"path\"><%= routeAttributes.path %></div>\n</div>\n</div>\n<%\nif(!routeAttributes.level){\n%><div class=\"separator\" /><%\n}\n}\n%>\n</section>\n</div>"
  , __filename = "components/templates/routeTrees/languageConnector.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var routeLanguageConnections = model.routeLanguageConnectionsSorted || {}
var targetRouteID, routeID, langCode
var routePickerButtonConfig = config.routePickerButtonConfig || {}
var description = model.description || {}

    ; __line = 6
    ; __append("\n<div>\n<section class=\"description ")
    ; __line = 8
    ; __append( description.class || '' )
    ; __append("\">\n<div class=\"symbol\">\n")
    ; __line = 10
    ; __append("<i class=\"")
    ; __append(escapeFn( description.icon || '' ))
    ; __append("\" />\n</div>\n<div class=\"content\">\n")
    ; __line = 13
    ; __append(escapeFn( description.content || '' ))
    ; __append("\n")
    ; __line = 14
    ; __append( description.contentSuffixHtml || '' )
    ; __append("\n</div>\n</section>\n<section class=\"main\">\n")
    ; __line = 18
    ; 
if(utils.collectionSize(model.availableLangCodes) < 1){

    ; __line = 20
    ; __append("<div class=\"empty\">")
    ; __append(escapeFn( storage.__('error:routeTree.missingAvailableLangCodes') ))
    ; __append("</div>")
    ; 
}
var routeAttributes = {};
var cssClasses = [];
var d, routeName = '', routeTitle = '';
for(d in resourceData.data.attributes.data || []){
routeAttributes = resourceData.data.attributes.data[d]
routeID = routeAttributes.routeID
routeName = routeAttributes.name
routeTitle = ''
if(model.extendByAdminConnectionInformation){
if(routeID){
if(!routeAttributes.level){
routeTitle = `#${routeID}`
} else if(routeAttributes.sourceRouteID && routeAttributes.targetRouteID) {
routeTitle = `#${routeID}   via   ${routeAttributes.sourceRouteID} => ${routeAttributes.targetRouteID}`
}
}
} else if(routeAttributes.path) {
routeTitle = routeAttributes.path
}
cssClasses = ['language']
if(routeAttributes.level > 1){
cssClasses.push('secondaryConnection')
}

    ; __line = 45
    ; __append("\n<div class=\"")
    ; __line = 46
    ; __append(escapeFn( cssClasses.join(' ') ))
    ; __append("\" data-route-id=\"")
    ; __append( routeAttributes.routeID )
    ; __append("\" data-lang-code=\"")
    ; __append(escapeFn( routeAttributes.langCode ))
    ; __append("\" style=\"--language-sub-level: ")
    ; __append( Math.max(routeAttributes.level, 1) - 1 )
    ; __append(";\" title=\"")
    ; __append(escapeFn( routeTitle ))
    ; __append("\">\n<div class=\"buttons\">\n")
    ; __line = 48
    ;  if(routeAttributes.level){ 
    ; __append("\n")
    ; __line = 49
    ; __append( include('../../base/form/elements/buttons/default', { formMapping: { buttonType: 'connectLanguage', context: 'route', symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 50
    ;  } 
    ; __append("\n")
    ; __line = 51
    ; __append( include('../../base/form/elements/buttons/default', { formMapping: { buttonType: 'open', context: 'routes', symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 52
    ;  if(routeAttributes.level === 1){ 
    ; __append("\n")
    ; __line = 53
    ; __append( include('../../base/form/elements/buttons/default', { formMapping: { buttonType: 'reset', context: 'routes', symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 54
    ; __append( include('../../base/form/fields/route-picker-button', { formMapping: {}, model: { fieldCode: routeAttributes.langCode, config: routePickerButtonConfig }}) )
    ; __append("\n")
    ; __line = 55
    ;  } 
    ; __append("\n</div>\n<div class=\"flag\">\n")
    ; __line = 58
    ; __append("<i class=\"")
    ; __append(escapeFn( (model.availableLangCodes[routeAttributes.langCode] || {}).icon || 'fi fi-flag' ))
    ; __append("\" title=\"")
    ; __append(escapeFn( routeAttributes.langCode ))
    ; __append("\" />\n</div>\n<div class=\"routeDetails\">\n<div>")
    ; __line = 61
    ; __append(escapeFn( routeName ))
    ; __append("</div>\n<div class=\"path\">")
    ; __line = 62
    ; __append(escapeFn( routeAttributes.path ))
    ; __append("</div>\n</div>\n</div>\n")
    ; __line = 65
    ; 
if(!routeAttributes.level){

    ; __line = 67
    ; __append("<div class=\"separator\" />")
    ; 
}
}

    ; __line = 70
    ; __append("\n</section>\n</div>")
    ; __line = 72
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/routeTrees/languageConnector.ejs

}